import React from 'react';

import { WithAlloySuspense } from '@adsk/alloy-react-suspense';

import AttachmentsHeader, {
  type AttachmentsHeaderProps,
} from './AttachmentsHeader';
import { useAttachmentsContext } from '../../context/AttachmentsContext';

type ConnectedAttachmentsHeaderProps = Pick<
  AttachmentsHeaderProps,
  'maxFileSize' | 'acceptFileTypes'
>;

const ConnectedAttachmentsHeader = ({
  maxFileSize,
  acceptFileTypes,
}: ConnectedAttachmentsHeaderProps) => {
  const { attachments, drafts, totalAttachments } = useAttachmentsContext();
  const totalAttachmentsCount =
    totalAttachments ?? attachments.length + drafts.length;

  return (
    <AttachmentsHeader
      numberOfAttachments={totalAttachmentsCount}
      maxFileSize={maxFileSize}
      acceptFileTypes={acceptFileTypes}
    />
  );
};

export default WithAlloySuspense(ConnectedAttachmentsHeader);
